import create from "zustand";
import { WindowData } from "../../js/components/RegularClassroomUser/utils";

export interface ClassroomScreenshotDataState {
	setStudentWindowData: (userId: string, data: WindowData[]) => void;
	getWindowDataForUser: (userId: string) => WindowData | undefined;
}

export const useClassroomScreenshotDataStore = create<ClassroomScreenshotDataState>((set) => {
	// Internal state, not exposed
	let windowDataMap: Record<string, WindowData[]> = {};

	return {
		setStudentWindowData: (userId, data) => {
			windowDataMap = { ...windowDataMap, [userId]: data };
			set({}); // trigger reactivity if needed
		},
		getWindowDataForUser: (userId) => {
			const userWindows = windowDataMap[userId];
			if (userWindows && userWindows.length > 0) {
				return userWindows[0];
			}
			return undefined;
		},
	};
});
